import { registerPlugin } from '@capacitor/core';
import type { PluginListenerHandle } from '@capacitor/core';

export interface FcmPushPlugin {
  register(): Promise<{ token: string | null }>;
  clearBadge(): Promise<void>;
  clearByChatId(options: { chatId: number }): Promise<void>;
  consumeLaunchNotification(): Promise<{ data: Record<string, string> | null }>;
  setSuppressMessengerBanners(options: { suppress: boolean }): Promise<void>;
  addListener(
    eventName: 'tokenRefresh',
    listenerFunc: (event: { token: string }) => void
  ): Promise<PluginListenerHandle>;
  addListener(
    eventName: 'notificationOpened',
    listenerFunc: (event: { data: Record<string, string> }) => void
  ): Promise<PluginListenerHandle>;
  addListener(
    eventName: 'messengerReadSync',
    listenerFunc: (event: { chatId: number }) => void
  ): Promise<PluginListenerHandle>;
}

export const FcmPush = registerPlugin<FcmPushPlugin>('FcmPush');
